import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import '../styles/QuizResults.css';

const QuizResults = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const {
    score = 0,
    totalQuestions = 0,
    quizType = '',
    quizId,
    responses = [],
    timeTaken = null
  } = location.state || {};

  const percentage = totalQuestions ? Math.round((score / totalQuestions) * 100) : 0;

  const getThemeData = () => {
    if (percentage >= 90) return { color: '#00ff88', title: '¡Misión Cumplida!', msg: 'Has demostrado un dominio excepcional.' };
    if (percentage >= 70) return { color: 'var(--accent)', title: 'Buen Desempeño', msg: 'Vas por el camino correcto hacia el ascenso.' };
    if (percentage >= 50) return { color: '#ffcc00', title: 'En Observación', msg: 'Aprobado, pero el servicio exige más precisión.' };
    return { color: '#ff4d4d', title: 'Repaso Crítico', msg: 'Se requiere estudio intensivo de inmediato.' };
  };

  const theme = getThemeData();

  // Generar consejos náuticos/estratégicos
  const getStudyTips = () => {
    const defaultTips = [
      "Analiza el glosario técnico en la sección de Biblioteca.",
      "Utiliza la IA Vortex para resumir los capítulos donde tuviste errores.",
      "Escucha los audios de este tema mientras realizas otras actividades."
    ];

    if (quizType === 'Legislación Naval') {
      return [
        "Repasa específicamente los artículos de la LOAM citados en tus errores.",
        "Utiliza fichas de estudio para los plazos y sanciones legales.",
        "Pide a la IA Vortex que te explique el contexto jurídico de tus fallos."
      ];
    }

    if (quizType === 'Conocimientos Marineros') {
      return [
        "Revisa las ilustraciones técnicas en el libro de Barbudo Duarte.",
        "Memoriza la terminología de maniobras y jarcias.",
        "Dibuja los esquemas de las partes del buque para fijar el conocimiento."
      ];
    }

    return defaultTips;
  };

  const handleAction = (path) => {
    if (path === 'retry' && quizId) {
      // Manejar reconexión a quiz original o generado
      const isGenerated = quizType === 'VortexDocs' || quizType === 'Personalizado';
      const basePath = isGenerated ? '/dashboard/quiz-generator/' : '/dashboard/quiz/';
      navigate(basePath + quizId);
    } else {
      navigate('/dashboard');
    }
  };

  if (!location.state) {
    return (
      <div className="results-container">
        <div className="results-card">
          <h1>No hay datos</h1>
          <button className="home-button" onClick={() => navigate('/dashboard')}>Ir al Inicio</button>
        </div>
      </div>
    );
  }

  return (
    <div className="results-container">
      <div className="results-card">
        <h1>{theme.title}</h1>
        <h2>Análisis Táctico: {quizType}</h2>

        <div className="score-display-section">
          <div className="score-circle" style={{ borderColor: theme.color }}>
            <div className="score-percentage" style={{ color: theme.color }}>{percentage}%</div>
            <div className="score-fraction">{score} / {totalQuestions}</div>
          </div>
          <div className="result-brief">
            <div className="result-message" style={{ color: theme.color }}>{theme.msg}</div>
            {timeTaken && <p>⏱️ Tiempo de ejecución: <strong>{timeTaken}</strong></p>}
            <p>📊 Precisión operativa: <strong>{percentage}%</strong></p>
          </div>
        </div>

        <div className="analysis-section">
          <div className="analysis-card">
            <h3>🛠️ Fortalezas</h3>
            <ul>
              {percentage >= 50
                ? <li>Interpretación rápida de premisas</li>
                : <li>Persistencia en la evaluación</li>}
              <li>Retención de conceptos base</li>
            </ul>
          </div>
          <div className="analysis-card">
            <h3>🎯 Áreas de Mejora</h3>
            <ul>
              {getStudyTips().map((tip, i) => <li key={i}>{tip}</li>)}
            </ul>
          </div>
        </div>

        {responses.length > 0 && (
          <div className="responses-list">
            <h3>🔍 Desglose de Operaciones</h3>
            {responses.map((res, i) => (
              <div key={i} className={`response-item ${res.isCorrect ? 'correct' : 'incorrect'}`}>
                <div className="response-question">
                  {res.isCorrect ? '✅' : '❌'} {res.questionText}
                </div>
                {!res.isCorrect && (
                  <div className="response-detail">
                    Respuesta correcta: <span className="correct-answer-text">{res.correctAnswer}</span>
                  </div>
                )}
              </div>
            ))}
          </div>
        )}

        <div className="action-buttons">
          <button className="retry-button" onClick={() => handleAction('retry')}>Nueva Incursión</button>
          <button className="home-button" onClick={() => handleAction('home')}>Centro de Mando</button>
        </div>
      </div>
    </div>
  );
};

export default QuizResults;